// var clipboard = new ClipboardJS('.copy-to-clipboard');
//
// clipboard.on('success', function(e) {
//
//     $(e.trigger).addClass('copy-animate');
//
//     e.clearSelection();
// });
//
// $('.copy-to-clipboard').on('click', function (e) {
//     e.preventDefault();
// });

import copy from "copy-to-clipboard";

((Drupal) => {
  Drupal.behaviors.share_copy = {
    attach(context) {
      const copyButtons = once(
        "share_copy_button",
        ".copy-to-clipboard",
        context
      );

      copyButtons.forEach((element) => {
        element.addEventListener("click", (event) => {
          event.preventDefault();
          event.target.parentElement.classList.add("copy-animate");
          const text = element.attributes["data-clipboard-text"].value;
          copy(text);
        });
        element.addEventListener("animationend", (event) => {
          event.target.classList.remove("copy-animate");
        });
      });
    },
  };
})(Drupal);
